/**
 * Box rotation lives in the signed range -180..180 (both ends allowed), the
 * convention most editors use so an element can be turned either way from 0.
 *
 * Values inside the range pass through untouched. Anything outside it — legacy
 * 0..360 data, or a stepper going one past either end — wraps into
 * (-180, 180], so holding the arrow keeps rotating instead of sticking at the
 * limit. Empty / non-numeric input is 0.
 */
export const ROTATION_MIN = -180;
export const ROTATION_MAX = 180;

export const normalizeRotation = (deg) => {
  const n = deg === "" || deg == null ? 0 : Number(deg);
  if (!Number.isFinite(n)) return 0;
  if (n >= ROTATION_MIN && n <= ROTATION_MAX) return n;
  const wrapped = ((n % 360) + 360) % 360;
  return wrapped > ROTATION_MAX ? wrapped - 360 : wrapped;
};
